import { gcApi } from '../config/axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_USAGE_INDICATORS,
    REQUEST_USAGE_INDICATORS,
    RECEIVE_USAGE_INDICATORS,
    RECEIVE_USAGE_INDICATORS_ERROR
} from '../actions/ActionTypes';

export function* fetchUsageIndicators(action) {
    try {
        yield put({
            type: REQUEST_USAGE_INDICATORS
        });

        const response = yield call(gcApi.get, `/web-gateway/snapshot/usageIndicators`);

        yield put({
            type: RECEIVE_USAGE_INDICATORS,
            data: response.data || {},
            receivedAt: Date.now()
        });
    } catch (error) {
        yield put({
            type: RECEIVE_USAGE_INDICATORS_ERROR,
            error: error,
            receivedAt: Date.now()
        });
    }
}

export const usageIndicatorsSagas = [takeEvery(FETCH_USAGE_INDICATORS, fetchUsageIndicators)];
